export default {
    setAuthCareerVideo (state, { videoObject }) {
        state.authCareerVideos = videoObject
    },
    setAuthInspirationVideo (state, { videoObject }) {
        state.authInspirationVideos = videoObject
    },
    setAuthMindbodyVideo (state, { videoObject }) {
        state.authMindbodyVideos = videoObject
    },
    setAuthMoodForSomethingElse (state, { mood }) {
        state.mainVideo = mood
    },
    setAuthWorkVideo (state, { videoObject }) {
        state.authWorkVideos = videoObject
    },
    setAuthMoneyVideo (state, { videoObject }) {
        state.authMoneyVideos = videoObject
    },
    setAuthLifeVideo (state, { videoObject }) {
        state.authLifeVideos = videoObject
    },
    setAuthRecommendedVideos (state, { videoObject }) {
        state.authRecommendedVideos = videoObject
    },
    setAuthRecentlyWatchedVideos (state, { videoObject }) {
        state.authRecentlyWatchedVideos = videoObject
    },
    setAuthQuestions (state, { questions }) {
        state.authQuestions = questions
    },
    setAuthUserVideos (state, { userVideos }) {
        state.authUserVideos = userVideos
    },
    setAuthUserFavVideos (state, {favVideos}) {
        state.authUserFavVideos = favVideos
    },
    setAuthRelatedVideos (state, {relVideos}) {
        state.authRelatedVideos = relVideos
    },
    setNewQuote (state, {quoteObj}) {
        state.authQuote = quoteObj
    },
    setAuthGreeting (state, {greetingObj}) {
        state.authGreeting = greetingObj
    },
    setToneTakeaways (state, {obj}) {
        state.toneTakeaways = obj
    },
    setToneTeasers (state, {obj}) {
        state.toneTeasers = obj
    },
    setAuthFunnies (state, {funniesObj}) {
        state.authFunnies = funniesObj
    }
}



// WEBPACK FOOTER //
// ./src/store/authpage/mutations.js